import { CustomersClient } from '@leid/api-customers'

const customersClient = (() => {
  const url = `http://${process.env.CUSTOMERS_URL}`
  const env = process.env.NODE_ENV
  const client = new CustomersClient(url, env)
  return client
})()

export default customersClient
